<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showLicenceDetails"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Licence Details</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="grid grid-cols-2 p-4 gap-3">
            <div class="text-sm">
              <label class="block pb-1">Organization Name</label>
              <input
                :value="licenceData.OrganizationName"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Orgaization Name"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Employees</label>
              <input
                :value="licenceData.Employees"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Leave Type"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Managers</label>
              <input
                :value="licenceData.Managers"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Leave Type"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                :value="formatDate(licenceData.StartDate)"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Leave Type"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">End Date</label>
              <input
                :value="formatDate(licenceData.ExpiryDate)"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Leave Type"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Status</label>
              <input
                disabled
                class="p-2 bg-gray-200 rounded-full w-full disabled border-0.5"
                v-model="licenceData.Status"
              />
            </div>
            <div class="col-span-2">
              <label>Licence Key</label>
              <input
                disabled
                :type="type"
                class="p-2 bg-gray-200 rounded-full w-full relative"
                :class="type === 'text' ? 'text-yellow-500 bold' : ''"
                placeholder="Licence Key"
                :value="licenceData.LicenseKey"
              />
              <img
                @click="showPassword"
                class="h-3 cursor-pointer absolute right-7 bottom-7"
                :src="type === 'password' ? hidePasswordIcon : showPasswordIcon"
              />
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "LicenceDetails",
  props: ["showLicenceDetails", "isSubmitted", "licenceData"],
  components: { Loader },
  data() {
    return {
      create_error: null,
      loading: false,
      inputDisabled: true,
      currentDate: null,
      dateError: false,
      LeaveTypes: [],
      selectedLeaveType: null,
      type: "password",
      showPasswordIcon: require("@/assets/icons/eye.png"),
      hidePasswordIcon: require("@/assets/icons/eye-crossed.png"),
      info: {
        LeaveType: null,
        StartDate: null,
        Period: null,
        date: null,
        EndDate: null,
        LeaveAttachment: "",
        Description: "",
        LeaveSpan: "Half Day",
      },
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
      this.type = "password";
    },

    formatDate(date) {
      return new Date(date).toISOString().substring(0, 10);
    },
    showPassword() {
      this.type = this.type === "password" ? "text" : "password";
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
